document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".tags-create") || document.querySelector(".tags-edit")) {
        //
    }
});
